<div class="health-notification-form">
    <al-bottom-sheet #alBottomSheet
                     [allowContent]="false"
                     [headerOptions]="headerOptions"
                     [footerOptions]="loading ? undefined : footerOptions"
                     (onPrimaryFooterAction)="onPrimaryAction()"
                     (onSecondaryFooterAction)="onBackAction()">
        <ng-template alHeaderTemplate>
            <al-notification-panel #notificationPanel
                [alertSource]="notificationsEmitterPopup"
                (onButtonClicked)="flushNotifications()">
            </al-notification-panel>
            <al-wizard-stepper #alWizard
                [loading]="loading"
                [headerOptions]="headerOptions"
                (onStepSelected)="onJumpStep($event)"
                (onCancelButton)="onSecondaryAction()">
                <al-view-helper></al-view-helper>
                <al-step stepTitle="Details">
                    <div class="details-column p-grid p-nogutter p-dir-col">
                        <div class="p-col-4 input-name p-mb-5">
                            <span class="md-inputfield">
                                <input type="text"
                                        class="p-col-12"
                                        name="formData.subscriptionName"
                                        [(ngModel)]="formData.subscriptionName"
                                        (ngModelChange)="editMode ? validateAllSteps() : validateStep(0)"
                                        pInputText
                                        required />
                                <label for="float-input">Name *</label>
                            </span>
                        </div>
                        <div class="p-col-4 p-mb-5">
                            <p-inputSwitch [(ngModel)]="formData.isActive"
                                            name="formData.isActive"></p-inputSwitch>
                            <span class="p-ml-3">Notification Is {{ formData.isActive ? 'Active' : 'Inactive'
                                }}</span>
                        </div>
                        <div class="p-col">
                            <p class="form-group-title p-mb-2">Collection Asset Type</p>
                            <div class="radio-group-options">
                                <p-radioButton name="agentStatus"
                                                value="agent"
                                                label="Agent"
                                                [disabled]="editMode"
                                                [(ngModel)]="formData.exposureType"
                                                (ngModelChange)="validateStep(0)"
                                                inputId="status1">
                                </p-radioButton>
                                <p-radioButton name="applianceStatus"
                                                value="appliance"
                                                label="Appliance"
                                                [disabled]="editMode"
                                                [(ngModel)]="formData.exposureType"
                                                (ngModelChange)="validateStep(0)"
                                                inputId="status2">
                                </p-radioButton>
                                <p-radioButton name="collectorStatus"
                                                value="collector"
                                                label="Collector"
                                                [disabled]="editMode"
                                                [(ngModel)]="formData.exposureType"
                                                (ngModelChange)="validateStep(0)"
                                                inputId="status3">
                                </p-radioButton>
                            </div>

                        </div>
                    </div>
                </al-step>
                <al-step stepTitle="Scope">
                    <div class="p-grid">
                        <div class="p-col-6" *ngIf="!enableHostSelection">
                            <div *ngIf="formData.exposureType === 'agent'">
                                <p class="form-group-title p-mb-2">Agent status *</p>
                                <div class="selector-option">
                                    <al-multiselect-list [options]="agentStatusOptions"
                                                            [readonly]="false"
                                                            placeholder="Select agent status"
                                                            [(ngModel)]="formData.selectedStatuses"
                                                            (onSelectionChanged)="statusChanged($event)">
                                    </al-multiselect-list>
                                </div>
                            </div>

                            <div *ngIf="formData.exposureType === 'appliance'">
                                <p class="form-group-title p-mb-2">Appliance status *</p>
                                <div class="selector-option">
                                    <al-multiselect-list [options]="applianceStatusOptions"
                                                            [readonly]="false"
                                                            [(ngModel)]="formData.selectedStatuses"
                                                            placeholder="Select appliance status"
                                                            (onSelectionChanged)="statusChanged($event)">
                                    </al-multiselect-list>
                                </div>
                            </div>

                            <div *ngIf="formData.exposureType === 'collector'">
                                <p class="form-group-title p-mb-2">Collector status *</p>
                                <div class="selector-option">
                                    <al-multiselect-list [options]="collectorStatusOptions"
                                                            [readonly]="false"
                                                            [(ngModel)]="formData.selectedStatuses"
                                                            placeholder="Select collector status"
                                                            (onSelectionChanged)="statusChanged($event)">
                                    </al-multiselect-list>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" *ngIf="enableHostSelection">
                            <p *ngIf="formData.exposureType === 'agent'" class="form-group-title p-mb-2">Agent Status *</p>
                            <p *ngIf="formData.exposureType === 'appliance'" class="form-group-title p-mb-2">Appliance Status *</p>
                            <p *ngIf="formData.exposureType === 'collector'" class="form-group-title p-mb-2">Collector Status *</p>
                            <div *ngFor="let option of getStatusVarOptions()">
                                <p-checkbox
                                    name="statusOptions"
                                    [value]="option.value"
                                    [label]="option.label"
                                    (onChange)="statusChanged([])"
                                    [(ngModel)]="formData.selectedChecksStatuses">
                                </p-checkbox>
                            </div>
                        </div>
                        <div class="p-col-12 p-nogutter" *ngIf="formData.exposureType !== 'collector' && !enableHostSelection">
                            <h5>Asset</h5>
                            <div class="health-notification-options">
                                <al-multiselect-list [options]="assetsOptions"
                                                    [readonly]="false"
                                                    placeholder="Select assets"
                                                    [(ngModel)]="formData.selectedAssets"
                                                    (onSelectionChanged)="scopeChanged($event)">
                                </al-multiselect-list>
                            </div>
                        </div>
                        <div class="p-col-12" *ngIf="(formData.exposureType !== 'collector' && enableHostSelection && formData.selectedChecksStatuses.length > 0)">
                            <p class="form-group-title p-mb-0">Define scope</p>
                            <div class="form-group-description">You must select at least one asset to receive notifications.</div>
                        </div>
                        <div class="p-col-12 p-nogutter"
                            [hidden]="!(formData.exposureType !== 'collector' && enableHostSelection && formData.selectedChecksStatuses.length > 0)">
                            <al-tree-table #alTreeTable
                                [loading]="loadingTreeTable"
                                [columns]="dataColumns"
                                [data]="assetsTree"
                                [visibleRows]="10"
                                [toolbarConfig]="toolbarConfig"
                                zeroStateIcon="al-assets"
                                zeroStateClassIcon="al"
                                [multiselection]="enableMultiselection"
                                zeroStateText="No assets were found."
                                (onDidSelectFilters)="onSelectedFilters($event)"
                                (onDidSelectRow)="onSelectedItem($event)"
                                (onDidDeselectRow)="onDeselectedItem($event)">
                                <al-detail-panel detailPanel *ngIf="selectedItem || selectedItems.length > 0"
                                    [icon]="getIconDetailPanel()"
                                    [iconClass]="getIconClassDetailPanel()"
                                    [header]="getHeaderDetailPanel()">
                                    <p-tabView>
                                        <p-tabPanel header="Settings">
                                            <div class="option-setting">
                                                <p class="mb-3">Enable notifications</p>
                                                <div class="radio-group-options">
                                                    <p-radioButton
                                                        name="enableNotificationOptions"
                                                        [value]="true"
                                                        [label]="onLabel"
                                                        [(ngModel)]="notificationActive">
                                                    </p-radioButton>
                                                    <p-radioButton
                                                        name="enableNotificationOptions"
                                                        [value]="false"
                                                        [label]="offLabel"
                                                        [(ngModel)]="notificationActive">
                                                    </p-radioButton>
                                                </div>
                                            </div>
                                            <div class="inherited-asset-link" *ngIf="inheritedParentAsset?.id !== '' && (selectedItems.length === 0)">
                                                <p>Inherited setting from</p>
                                                <p class="asset-link">
                                                    <a (click)="goToInheritedAsset()">
                                                        <i [ngClass]="[inheritedParentAsset?.iconClass ? inheritedParentAsset?.iconClass : 'material-icons']">
                                                            {{ inheritedParentAsset?.icon }}
                                                        </i>
                                                        {{inheritedParentAsset?.label}}
                                                    </a>
                                                </p>
                                            </div>
                                            <ng-container *ngIf="showRemoveChildren() && (selectedItems.length === 0)">
                                                <div class="option-setting">
                                                    <al-alert-box boxColor="orange">
                                                        <div class="icon">
                                                            <i class="material-icons" ngClass="orange">info</i>
                                                        </div>
                                                        <div class="text">
                                                            There are sub-existing rules applied.
                                                        </div>
                                                    </al-alert-box>
                                                </div>
                                                <div class="option-setting">
                                                    <p-checkbox [(ngModel)]="removeChildRules" binary="true" inputId="removeChildRules"></p-checkbox>
                                                    <label for="removeChildRules">Apply and override all children settings.</label>
                                                </div>
                                            </ng-container>
                                            <div class="option-setting">
                                                <button (click)="applyNotificationRule(selectedItem)"
                                                    [disabled]="disableApplyButton()"
                                                    pButton
                                                    type="button"
                                                    class="action-button"
                                                    label="Apply">
                                                </button>
                                            </div>
                                        </p-tabPanel>
                                        <p-tabPanel header="Information" *ngIf="selectedItems.length === 1 || selectedItems.length === 0">
                                            <al-data-field label="Deploment ID" [value]="selectedItem?.data?.deploymentId"></al-data-field>
                                            <al-data-field label="Name" [value]="selectedItem?.data?.name"></al-data-field>
                                            <al-data-field label="Key" [value]="selectedItem?.data?.key"></al-data-field>
                                            <al-data-field label="Type" [value]="selectedItem?.data?.assetType"></al-data-field>
                                        </p-tabPanel>
                                    </p-tabView>
                                </al-detail-panel>
                            </al-tree-table>
                        </div>
                    </div>
                </al-step>
                <al-step stepTitle="Delivery">
                    <al-notification-form [loading]="loading"
                                            [accountId]="accountId"
                                            [showAttach]="false"
                                            [editMode]="editMode"
                                            type="health/alerts"
                                            (onChanged)="onSubscribersChanged()">
                        <div class="p-grid p-dir-col">
                            <div class="p-col-12 padding-bottom-0">
                                <h1 class="columnHeader">Preferences</h1>
                            </div>
                            <div class="p-col-12 padding-top-0">
                                <h5>Delay</h5>
                                <div class="p-col section-title no-padding justify-text">
                                    Health exposures that are resolved before the set delay will not send the notification.
                                </div>
                                <div class="selector-option">
                                    <p-dropdown
                                        [options]="policyOptions"
                                        [(ngModel)]="healthPolicySelected"
                                        optionLabel="title">
                                    </p-dropdown>
                                </div>
                                <h5>Suppression</h5>
                                <div class="p-col section-title no-padding">Suppress notifications after the first for the set time.</div>
                                <div class="selector-option">
                                    <p-dropdown
                                        [options]="governanceOptions"
                                        [(ngModel)]="healthGovernanceSelected"
                                        optionLabel="title">
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>
                    </al-notification-form>
                </al-step>
            </al-wizard-stepper>
        </ng-template>
    </al-bottom-sheet>
</div>
